import produce from "immer"
import {findCareSource} from '../commons/CareSource'
import {findSource} from '../commons/RecruitmentSource'
import {findRelate} from '../commons/CsRelationShip'
import moment from 'moment-mini';

const MemberReducer = produce((draft = {}, action={}) => {
  switch (action.type) {
    case "FETCH_MEMBER":
      draft.loading = true
      delete draft.error
      return draft
    case "PUT_MEMBER_SUCCESS":
    case "FETCH_MEMBER_SUCCESS":
      draft = action.payload.data
      if(draft.birthday){
        draft.birthday = moment(draft.birthday)
      }
      draft.gender = draft.gender+1
      if(draft.avatar){
        draft.avatar = draft.avatar.includes("/upload/avatars") ? process.env.REACT_APP_V1_NPV_CRM_PATH + draft.avatar : process.env.REACT_APP_FILE_API + "file/" + draft.avatar + "?size=480"
      }
      if(draft.main_dealer){
        draft.main_dealer.key = draft.main_dealer.id.toString()
        draft.main_dealer.label = draft.main_dealer && draft.main_dealer.short_name ? draft.main_dealer.short_name.toString() : ""
        draft.main_dealer.title = draft.main_dealer && draft.main_dealer.name ? draft.main_dealer.name.toString() : ""
      }
      if(draft.sub_dealer){
        draft.sub_dealer.key = draft.sub_dealer.id.toString()
        draft.sub_dealer.label = draft.sub_dealer && draft.sub_dealer.short_name ? draft.sub_dealer.short_name.toString() : ""
        draft.sub_dealer.title = draft.sub_dealer && draft.sub_dealer.name ? draft.sub_dealer.name.toString() : ""
      }
      if(draft.sub_dealer_1){
        draft.sub_dealer_1.key = draft.sub_dealer_1.id.toString()
        draft.sub_dealer_1.label = draft.sub_dealer_1 && draft.sub_dealer_1.short_name ? draft.sub_dealer_1.short_name.toString() : ""
        draft.sub_dealer_1.title = draft.sub_dealer_1 && draft.sub_dealer_1.name ? draft.sub_dealer_1.name.toString() : ""
      }
      if(draft.sub_dealer_2){
        draft.sub_dealer_2.key = draft.sub_dealer_2.id.toString()
        draft.sub_dealer_2.label = draft.sub_dealer_2 && draft.sub_dealer_2.short_name ? draft.sub_dealer_2.short_name.toString() : ""
        draft.sub_dealer_2.title = draft.sub_dealer_2 && draft.sub_dealer_2.name ? draft.sub_dealer_2.name.toString() : ""
      }
      if(draft.bank_info && draft.bank_info.city && draft.bank_info.city.key){
        draft.bank_info.city.key = draft.bank_info.city.key.toString()
      }
      if(draft.extend_data && draft.extend_data.care_source && !draft.extend_data.care_source.id){
        draft.extend_data.care_source = findCareSource(draft.extend_data.care_source)
      }
      if(draft.extend_data && draft.extend_data.recruitment_source && !draft.extend_data.recruitment_source.id){
        draft.extend_data.recruitment_source = findSource(draft.extend_data.recruitment_source)
      }
      if(draft.cs && draft.cs.status && !draft.cs.status.id){
        draft.cs.status = findRelate(draft.cs.status)
      }
      draft.loading = false
      return draft
    case "PUT_MEMBER_BANK_SUCCESS":
      // draft
      draft.bank_owner = action.payload.member_info.bank_owner
      draft.bank_number = action.payload.member_info.bank_number
      draft.bank_info = {
        bank: action.payload.bank,
        city: action.payload.city,
        branch: action.payload.branch,
      }
      return draft
    case "CLEAR_MEMBER_BANK_SUCCESS":
      // draft
      draft.bank_owner = action.payload.member_info.bank_owner
      draft.bank_number = action.payload.member_info.bank_number
      draft.bank_name = action.payload.member_info.bank_name
      draft.bank_branch = action.payload.member_info.bank_branch
      draft.bank_info = null
      return draft
    case "FETCH_MEMBER_FAILED":
      draft.loading = false
      draft.error = true
      return draft
    case "CLEAR_MEMBER":
      draft = {}
      return draft
    default:
      return draft
  }
})

export default MemberReducer;